import type {
  AdvertiserGroupServerType,
  AdvertiserGroupType,
} from '@/lib/types/advertiser-groups.types'

export const normalizeAdvertiserGroups = (
  data: AdvertiserGroupServerType[] = [],
): AdvertiserGroupType[] => {
  return data
    .map((item) => ({
      name: item.name,
      id: item.id,
      currency: item.currency,
      returnAdUserId: item.return_ad_user_id,
    }))
    .sort((a, b) => a.name.localeCompare(b.name))
}
